/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".thankyou[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]{position:relative;padding:200px;display:flex;flex-direction:row;justify-content:center}.thankyou[_ngcontent-%COMP%]   .container[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:inline-block}"];
export { styles as styles };
